import { Kpi, ChartCard, Bars, Donut, LineTrend, HBar, fmtZAR } from "./widgets";

export default function SalesAnalytics({ data }) {
  return (
    <div className="space-y-4">
      {/* KPI row */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="sales-kpis">
        <Kpi label="Pipeline value" value={fmtZAR(data.pipeline_value)} accent="#A78BFA" testId="kpi-pipeline-value" />
        <Kpi label="Win rate" value={data.win_rate_pct} unit="%" accent="#10B981" testId="kpi-win-rate" note={`${data.wins || 0} won · ${data.losses || 0} lost`} />
        <Kpi label="Avg deal size" value={fmtZAR(data.avg_deal_size)} accent="#F59E0B" testId="kpi-avg-deal" />
        <Kpi label="Total won value" value={fmtZAR(data.total_won_value)} accent="#1FB6C1" testId="kpi-total-won" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <ChartCard title="Pipeline by phase" desc="Open leads grouped by phase" testId="chart-pipeline-phase">
          <Bars data={data.pipeline_by_phase} xKey="phase" yKey="count" color="#A78BFA" />
        </ChartCard>
        <ChartCard title="Lead sources" desc="Top sources all-time" testId="chart-lead-sources">
          <Donut data={data.lead_sources} nameKey="source" valueKey="count" />
        </ChartCard>
        <ChartCard title="Leads created" desc="Daily lead volume in window" testId="chart-leads-trend">
          <LineTrend data={data.leads_trend} xKey="date" yKey="count" color="#A78BFA" />
        </ChartCard>
        <ChartCard title="Rep leaderboard" desc="Wins in window" testId="chart-rep-leaderboard">
          <HBar data={data.rep_leaderboard} labelKey="name" valueKey="wins" color="#10B981" />
        </ChartCard>
      </div>
    </div>
  );
}
